/**
 * This is a helper to track the state of keyboard focus on a grid.
 *
 * This will attempt to find the same cell.
 * If it can not find the same cell, it will go back to the top of the grid.
 * @param grid
 * @constructor
 */
var SavedKeyboardFocus = function(grid) {
    this.column = -1;
    this.row = -1;
    var cell = grid.current();
    if (cell && cell.length) {
        var row = cell.parent();
        var real_cell = cell[0];
        this.column = row.children().toArray().indexOf(real_cell);
        if(cell.parent().parent("thead").length === 0) {
            var item = grid.dataItem(row);
            if (item) {
                this.row = item.id;
            }
        }
    }
};

SavedKeyboardFocus.prototype.restore = function(grid) {
    var row;
    if (this.row === -1) {
        row = grid.thead.find("tr");
    } else {
        var item = grid.dataSource.get(this.row);
        if (item) {
            row = grid.tbody.find("tr[data-uid='" + item.uid + "']");
        }
    }

    if (row && row.length) {
        var cell = row.find("td:nth-child(" + (this.column + 1) + ")");
        grid.current(cell);
    }
};

export default SavedKeyboardFocus;
